import React, { Component } from "react";
import { Card, CardBody, Progress } from "reactstrap";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import ReportsPanel from "./reports-panel";

import {alertActions, apiActions, commonActions} from "../../_actions";
import { appConstants } from "../../_constants";
import {appHelpers, store} from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
// import ReportIcon from 'react-icons/lib/md/insert-chart';

//react-redux comm
import { connect } from "react-redux";
// import {} from "../../_actions";

import ViewHeader from "./view-header";

// styling
import "./style.css";
import PageSuccessMessage from "../utils/pageSuccess";
import { operationsService } from "../../_services/operations.service";
const travelRoutes = [
  { label: "All", value: "" },
  { label: "International", value: "International" },
  { label: "Domestic", value: "Domestic" }
];

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class PassengerLevelData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      airline: [],
      AirlineId: "",
      startDate: moment().startOf('month').format("YYYY-MM"),
      endDate: new Date(),
      travelRouteOptions: travelRoutes,
      selectValue: { label: "All", value: "All" },

      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },
      finalDestinationReports: false,
      finalDestinationErrorMessage: "",
      SourceAirlineId: [],
      PassengerDataReport: "",
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;

    const reduxState = store.getState();
    let { airlinesCarriers } = reduxState;
    if (airlinesCarriers) {
      this.setState({ airlines: airlinesCarriers.Results })
    } else {
      this.fetchAirlines();
    }

  }

  //update selected category
  updateTravelRouteValue = newValue => {
    this.setState({
      selectValue: newValue
    });
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  generatePassengerLevelData = () => {
    const { dispatch } = this.props;
    let { startDate, endDate, selectValue , SourceAirlineId} = this.state;
    const { authentication } = store.getState();

    this.setState({ contentError: false });

    let isLocal = "";
    startDate = moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
    endDate =  moment(endDate).format("YYYY-MM-DD") + "T23:59:59"

    if (!selectValue) {
      isLocal = "";
    } else if (selectValue.value === "International") {
      isLocal = false;
    } else if (selectValue.value === "Domestic") {
      isLocal = true;
    }

    let payload = {
      startdate: startDate,
      enddate: endDate,
      airlineId: SourceAirlineId.map(airline => airline.Id),
      islocal: isLocal,
      NotifyEmail:authentication.user.userName,
    };

    dispatch(apiActions.startRequest());
    operationsService.getPassengerLevelData(payload)
        .then((res) => {
          if (res.status === appConstants.SUCCESS_RESPONSE) {
            dispatch(apiActions.endRequest());
            let response = res.response.data;
            console.log("API Error Response:", res);
            this.setState({
              PassengerDataReport: response,
            });
            this.notify("Received, report will be sent to user mail when processing is done", appConstants.NOTIFY_SUCCESS);
          }
          else if (res.status === appConstants.ERROR_RESPONSE) {
            const errorMessage = res.response || "An unexpected error occurred.";
            
            this.notify(errorMessage, appConstants.NOTIFY_ERROR); // Show notification
            
            dispatch(alertActions.error(errorMessage)); // Dispatch error action
            dispatch(apiActions.endRequest());
        }
        });
  };

  fetchAirlines = () => {
    this.setState({ contentError: false });
    const { dispatch, airlinesCarriers } = this.props;
    if (!airlinesCarriers) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startRequest());
    }

    dispatch(commonActions.getAirlinesCarriers())
        .then(() => {
          let { airlinesCarriers } = this.props;
          this.setState({ airlines: airlinesCarriers.Results });
          dispatch(apiActions.endRequest());
        }).catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      this.notify(errorMessage, appConstants.NOTIFY_ERROR);
      this.setState({ contentError: errorMessage });
      dispatch(apiActions.endRequest());
    });
  };


  handleSelectChange = (payload, attribute) => {
    let currState = this.state;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    currState[attribute] = (payload) ? payload[attribute] : ''; //Cater for setting up data and clearing data
    if (!payload) {
      currState[attribute] = '';
    }
      else {
        currState[attribute] = payload.Id;
    }
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });

  };

  handleAirlineSelectChange = (payload, attribute, stateAttribute) => {
    let currState = { ...this.state };
  
    if (Array.isArray(payload)) {
      currState[stateAttribute] = payload; // ✅ Store full objects, not just IDs
    } else {
      currState[stateAttribute] = payload ? payload : null;
    }
  
    let errorMessages = { ...this.state.componentErrorMessages };
    errorMessages[stateAttribute] = false;
  
    this.setState({
      ...currState,
      componentErrorMessages: errorMessages,
    });
  };
  
  

  render() {
    const {
      travelRouteOptions,
      selectValue,
      contentError,
      finalDestinationReports,
      SourceAirlineId,
      componentErrorMessages,
        airlines,
      finalDestinationErrorMessage
    } = this.state;
    const { requesting, pageRequesting } = this.props;
    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) &&
              !pageRequesting && (
                <Progress
                  striped
                  animated
                  color="success"
                  value={100}
                  className="mb-2"
                />
              )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}


            {/*Display component content when Data is gotten from API*/}
            {!contentError &&
              !pageRequesting && (
                <CardBody>
                  <h6 className="mb-0 text-uppercase pull-left">
                    Passenger level data Panel
                  </h6>

                  <div className="clearfix">&nbsp;</div>
                  <ReportsPanel
                    travelRoutes={travelRouteOptions}
                    selectedTravelRoute={selectValue}
                    onTravelRouteValueChange={this.updateTravelRouteValue}
                    onSearch={this.generatePassengerLevelData}
                    startDateChange={startDate => this.setState({ startDate })}
                    endDateChange={endDate => this.setState({ endDate })}
                    SourceAirlineId={SourceAirlineId}
                    handleAirlineSelectChange={this.handleAirlineSelectChange}
                    componentErrorMessages={componentErrorMessages}
                    airlines={airlines}
                    requesting={requesting}
                  />
                  <CardBody>
                    {!requesting &&
                      finalDestinationReports === null && (
                        <PageEmptyContent message={finalDestinationErrorMessage}/>
                      )}

                    {!requesting && !contentError && finalDestinationReports &&
                    <PageSuccessMessage successMessage={"Report generated successfully"}/>
                    }
                    {requesting && <div></div>}
                  </CardBody>
                </CardBody>
              )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { alert, airlinesCarriers } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    alert,
    airlinesCarriers
  };
}

export default connect(mapStateToProps)(PassengerLevelData);

// Written by Juliet February 2010


// WEBPACK FOOTER //
// ./src/views/passenger-level-data/index.js